/**
 * Gets the validation attributes for a HTMLInputElement instance.
 * @param input The input element.
 * @returns Object containing the attributes.
 */
export function getValidationAttributes(input: HTMLInputElement) {
	const atts: any = {};
	apply(input, atts, "data-val");
	apply(input, atts, "data-val-required");
	apply(input, atts, "data-val-length");
	apply(input, atts, "data-val-length-max");
	apply(input, atts, "data-val-regex");
	apply(input, atts, "data-val-regex-pattern");
	return atts;
}

function apply(input: HTMLInputElement, target: any, name: string) {
	const dataVal = input.getAttribute(name);
	if (dataVal) {
		target[name] = dataVal;
	}
}